import { render, staticRenderFns } from "./ChordProEditor.vue?vue&type=template&id=2eeccc80&scoped=true"
import script from "./ChordProEditor.vue?vue&type=script&lang=ts"
export * from "./ChordProEditor.vue?vue&type=script&lang=ts"
import style0 from "./ChordProEditor.vue?vue&type=style&index=0&id=2eeccc80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeccc80",
  null
  
)

export default component.exports